import { Account } from "../accounts";
import { QueryClient } from "../signers/cosmos";
import { ThorchainExtension } from "../signers/cosmos/modules/thorchain/queries";
import { EncodeObject } from "../signers/cosmos/proto-signing";
import { THOR } from "../network";
import { BaseMsg, Msg, RedactedContext } from "./msg";
import { MsgRedactedBatchCalls } from "./private";

export class MsgMulti extends BaseMsg implements Msg {
  constructor(
    public account: Account,
    private msgs: Msg[]
  ) {
    super();
  }
  async toCosmosTx(): Promise<{ msgs: EncodeObject[]; memo: string }> {
    const encoded = await Promise.all(this.msgs.map((a) => a.toCosmosTx()));
    if (encoded.filter((a) => !!a.memo).length > 1)
      throw new Error(`MsgMulti does not support multiple memos`);
    return {
      msgs: encoded.flatMap((a) => a.msgs),
      memo: encoded.find((a) => !!a.memo)?.memo || "",
    };
  }
  withQueryClient(q: QueryClient & ThorchainExtension): void {
    this.msgs.forEach((x) => x.withQueryClient?.(q));
  }

  toPrivate(ctx: RedactedContext): MsgRedactedBatchCalls {
    const calls = this.msgs.map((msg) => {
      if (!msg.toPrivateCall) {
        throw new Error("Private batch contains an unsupported message");
      }
      return msg.toPrivateCall();
    });
    if (calls.length === 0) {
      throw new Error("Private batch cannot be empty");
    }
    return new MsgRedactedBatchCalls(
      { address: ctx.publicAddress, network: THOR },
      ctx.stealth,
      calls
    );
  }

  toPrivateV2(ctx: RedactedContext): MsgRedactedBatchCalls {
    if (this.account.network !== THOR) {
      throw new Error("Private batches require a THORChain source account");
    }
    const calls = this.msgs.map((msg) => {
      if (!msg.toPrivateV2Call) {
        throw new Error("Private batch contains an unsupported message");
      }
      return msg.toPrivateV2Call();
    });
    if (calls.length === 0) {
      throw new Error("Private batch cannot be empty");
    }
    return new MsgRedactedBatchCalls(
      { address: ctx.publicAddress, network: THOR },
      ctx.stealth,
      calls
    );
  }
}
